import React from 'react';
import { myCoursesFilter } from '../../../../utils/const';
import { connect } from 'react-redux';
import { compose } from 'redux';
import IWantToFilterItems from './iWantToFilter.options';

const mapStateToProps = (state) => {
	const { listItem } = state.rootReducer.myCourse;
	return {
		listItem,
	};
};

const IWantToFilter = ({ listItem, setElementFilter, elementFilter }) => {
	return (
		<form className="form-inline pull-right">
			<div className="form-group">
				<label htmlFor="exampleInputName2">I want to </label>

				<div className="dropdown filter-control">
					<input
						type="text"
						className="form-control step-filter-form dropdown-toggle filter-img-border"
						data-toggle="dropdown"
						id="filter_text"
						placeholder="Improve All Skills"
						readOnly
					/>

					<ul className="dropdown-menu" id="list">
						{listItem &&
							listItem.map((item) => (
								<IWantToFilterItems
									key={item}
									theme={item}
									{...myCoursesFilter[item]}
									setElementFilter={setElementFilter}
									elementFilter={elementFilter}
								/>
							))}
					</ul>
				</div>
			</div>
		</form>
	);
};

export default compose(connect(mapStateToProps))(IWantToFilter);
